export default [
  { 
    path: '/slide', 
    name: 'Slide', 
    component: () => import('@/views/slide/Index'),
    meta: {
      breadcrumbs: [
        { text: 'สไลด์', disabled: true }
      ]
    }
  },
]